const React = require('react');

function BlogComparison({ kind }) {
  const companies = kind === 'companies';
  const cards = companies ? [
    ['Company A', ['Vague homepage messaging', 'One short services page', 'Unclear service area', 'Limited service detail', 'Few project examples', 'Little experience information']],
    ['Company B', ['Clear service/location messaging', 'Dedicated service pages', 'Clear service areas', 'Useful content', 'Consistent business information', 'Specific reviews', 'Project examples/photos', 'Experience information']],
  ] : [['Google Search', ['List of results']], ['AI Search', ['Conversational recommendation']]];
  const h = React.createElement;
  return h('figure', { className: 'blog-comparison', 'aria-label': companies ? 'Company A versus Company B' : 'Traditional search versus AI search' },
    cards.map(([title, items], index) => h(React.Fragment, { key: title },
      index > 0 && h('span', { className: 'blog-comparison-vs' }, 'VS'),
      h('div', { className: 'blog-comparison-card' }, h('strong', null, title),
        !companies && h('span', { className: 'blog-comparison-arrow', 'aria-hidden': true }, '↓'),
        companies ? h('ul', null, items.map(item => h('li', { key: item }, item))) : h('p', null, items[0])))));
}
module.exports = BlogComparison;
